import React, { useEffect, useRef, useState } from "react";
import { styled } from "@mui/material/styles";
import clsx from "clsx";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { connect } from "react-redux";
import Avatar from "@mui/material/Avatar";
import BusApiCall from "./axios";
import constants from "./constants";
import axios from "axios";
import {
  Tooltip,
  IconButton,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Paper,
} from "@mui/material";
import { withTranslation } from "react-i18next";
import actionTypes from "../store/actions";
import { WhiteChatIcon } from "../component/icons/icons";
import Draggable from "react-draggable";
import CloseIcon from "@mui/icons-material/Close";

var jwtToken = null;
let chatLoadCount = 0;

// Styled Paper used inside draggable wrapper (replaces makeStyles)
const ResizablePaper = styled(Paper)(({ theme }) => ({
  resize: "both",
  overflow: "auto",
  minWidth: 640,
  minHeight: 200,
  maxWidth: "90vw",
  maxHeight: "90vh",
  width: "60vw",
}));

const ZulipChat = (props) => {
  const chatIframeRef = useRef(null);
  const intialChatIframeRef = useRef(null);
  const [userName, setUserName] = useState("");
  const [zulipLoadError, setZulipLoadError] = useState(false);

  // Run once on mount
  useEffect(() => {
    generateJWTToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const generateJWTToken = () => {
    var user = JSON.parse(localStorage.getItem("roles"));
    if (user && user.data && user.data.loggedInUser) {
      // Define your secret key
      const secretKey =
        "f629bf3202f6a9442e6db4b35a4e7a45c1d394adeb2dc5316e5db69c3a330147";

      // Get current timestamp in seconds
      const currentTimeInSeconds = Math.floor(Date.now() / 1000);

      const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      var user = JSON.parse(localStorage.getItem("roles"));
      var tenantInfo = JSON.parse(localStorage.getItem("tenantInfo"));
      var tenantId = tenantInfo.tenantId;
      var userId = user.data.loggedInUser.userId;
      setUserName(user.data.loggedInUser.userName);
      var userLoginId = "";
      var isValid = pattern.test(userId);
      if (isValid) {
        userLoginId = userId;
      } else {
        userLoginId = userId + "@" + tenantId + ".local";
      }

      var payload = {
        header: {
          alg: "HS256",
          typ: "JWT",
          kid: "",
        },
        payload: {
          // iss: "zulip.iotmarketplace.net:7443",
          sub: userLoginId, // Zulip user email
          realm: "", // Zulip organization
          iat: currentTimeInSeconds, // Issued at time
          exp: currentTimeInSeconds + 24000 * 60 * 60, // Expiry time (24000 hours)
          email: userLoginId,
        },
        secretKey: secretKey,
      };

      // Generate JWT token
      BusApiCall("POST", `${constants.busOpenServiceUrl}/auth/tmpjwt`, payload)
        .then((res) => {
          jwtToken = res.data.jwtToken;
          if (jwtToken) {
            if (props.authenticated && chatLoadCount === 0) {
              var url =
                constants.zulipBaseUrl +
                "/accounts/login/jwt/?token=" +
                jwtToken;
              axios
                .post(url, "", { withCredentials: true })
                .then((response) => {
                  // console.log('check zulip response', response);
                  setZulipLoadError(false);
                  if (intialChatIframeRef.current) {
                    const doc =
                      intialChatIframeRef.current.contentDocument ||
                      intialChatIframeRef.current.contentWindow.document;
                    doc.open();
                    doc.write(response.data);
                  }
                  chatLoadCount++;
                })
                .catch((error) => {
                  // setZulipLoadError(true);
                  console.log("check zulip error", error);
                  console.log("check zulip error", JSON.stringify(error));
                });
            }
          }
        })
        .catch((err) => {
          console.log("error generating jwt token", err);
          // you previously had optional error messaging here
        });
    }
  };

  const [openChat, toggleChatDialog] = useState(false);
  const openChatDialog = () => {
    toggleChatDialog(true);
    setTimeout(() => {
      var url =
        constants.zulipBaseUrl + "/accounts/login/jwt/?token=" + jwtToken;
      axios
        .post(url, "", { withCredentials: true })
        .then((response) => {
          if (chatIframeRef.current) {
            const doc =
              chatIframeRef.current.contentDocument ||
              chatIframeRef.current.contentWindow.document;
            doc.open();
            doc.write(response.data);
          }
        })
        .catch((error) => {
          console.log("heck error", error);
        });
    }, 1000);
  };

  const closeChatDialog = () => {
    toggleChatDialog(false);
  };

  const inactiveIcon = (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0Z"
        fill="#C4C4C4"
      />
    </svg>
  );
  const activeIcon = (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18C13.9706 18 18 13.9706 18 9Z"
        fill={props.tenantData?.color}
        fillOpacity="0.15"
      />
      <path
        d="M9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5Z"
        fill={props.tenantData?.color}
      />
    </svg>
  );
  const completedIcon = (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0Z"
        fill={props.tenantData?.color}
      />
    </svg>
  );

  return (
    <>
      <IconButton
        onClick={() => openChatDialog()}
        className="zulip-chat-trigger-button"
      >
        <WhiteChatIcon />
      </IconButton>

      <Dialog
        open={openChat}
        disableScrollLock={true}
        maxWidth="lg"
        fullWidth
        PaperComponent={DraggableWrapper}
        PaperProps={
          {
            // DraggableWrapper will receive these props and render ResizablePaper
            // we do not need to pass a className as before
          }
        }
      >
        <DialogTitle id="chat_dialog_title" style={{ cursor: "move" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span>
              {props.t("WELCOME")}: {userName}
            </span>
            <Tooltip title={props.t("CLOSE")}>
              <IconButton
                edge="end"
                onTouchStart={(event) => closeChatDialog()}
                onClick={(event) => closeChatDialog()}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </div>
        </DialogTitle>

        <Divider />

        <DialogContent style={{ height: "600px" }}>
          {zulipLoadError ? (
            <div
              style={{
                fontSize: 20,
                fontWeight: "bold",
                textAlign: "center",
                lineHeight: "500px",
              }}
            >
              {props.t("ZULIP_LOAD_ERROR_MESSAGE")}
            </div>
          ) : (
            <iframe
              ref={chatIframeRef}
              style={{ width: "100%", height: "530px", border: "none" }}
              title="dynamic-iframe"
              src={constants.zulipUiUrl}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* hidden initial iframe used to pre-load content */}
      <iframe
        ref={intialChatIframeRef}
        style={{ width: "1px", height: "1px" }}
        src={constants.zulipUiUrl}
        title="initial-zulip"
      />
    </>
  );
};

const DraggableWrapper = (props) => {
  // Paper props will be forwarded to ResizablePaper via {...props}
  const nodeRef = useRef(null);
  return (
    <Draggable
      nodeRef={nodeRef}
      bounds={"parent"}
      defaultClassName="customReactDraggableComponent"
      handle="#chat_dialog_title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <ResizablePaper ref={nodeRef} {...props} />
    </Draggable>
  );
};

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
    tenantId: state.auth.tenantId,
    tenantData: state.auth.tenantData,
    locale: state.auth.tenantLocale,
    publicBrowsing: state.auth.publicBrowsing,
    roles: state.auth.roles,
    tenantInfo: state.auth.tenantInfo,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
    clearCart: () => dispatch({ type: actionTypes.CLEAR_CART }),
    setCountriesList: (data) =>
      dispatch({ type: actionTypes.SET_COUNTRIES_LIST, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(ZulipChat));
